// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__31DZe","imageUploader":"EGiftCard_imageUploader__FZnpf"};